import axios from "axios";
import { TRAINING_COLLECTION, TRAIN_VOICE_URL, USER_COLLECTION } from "config";
import { addDoc, collection, doc, getDoc } from "firebase/firestore";
import { db } from "services/firebase";

export const transferVoice = async (uid: string, files: File[]) => {
    const trainingDocRef = await addDoc(collection(db, TRAINING_COLLECTION), {
        uid
    });
    const trainingId = trainingDocRef.id;

    // TODO
    // upload files to backend TRAIN_VOICE_URL
    const formData = new FormData();
    files.forEach((file: File) => {
        formData.append("files", file);
    });
    formData.append("uid", uid);
    formData.append("training-id", trainingId);
    formData.append("numFiles", files.length.toString());
    console.log("numFiles", files.length.toString());

    try {
        await axios.post(TRAIN_VOICE_URL, formData,{
            headers: {
                'Content-Type': 'multipart/form-data'
            }
        })
    } catch (error) {
        throw error;
    }
}

export const getVoiceTransfers = async (uid: string) => {
    try {
        const user = await getDoc(doc(db, USER_COLLECTION, uid));
        const trainingIds = user.data()!.training_ids;
        if(!trainingIds) return [];
        const contentDocs = await Promise.all(trainingIds.map(async (trainingId: string) => {
            const contentDoc = await getDoc(doc(db, TRAINING_COLLECTION, trainingId));
            return contentDoc.data();
        }));
        return contentDocs;
    } catch (error) {
        throw error;
    }
}